module.exports = __webpack_public_path__ + "img/hr-rock-medium-07.552292dc.png";